import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { PiCaretLeft, PiCaretRight } from 'react-icons/pi'

interface LinkType {
  activeLinkCondition?: boolean
  label: string
  to: string
  testId: string
  Icon?: React.ComponentType<React.SVGProps<SVGSVGElement>>
}

interface TabsProps {
  links: LinkType[]
}

const Tabs: React.FC<TabsProps> = ({ links }) => {
  const { pathname } = useLocation()
  return (
    <div className="min-w-full overflow-x-auto bg-primary flex gap-4 justify-around items-stretch px-4">
      <div className="flex flex-col justify-center text-lg">
        <PiCaretLeft color="white" />
      </div>
      {links.map((link) => {
        const isActive = link.activeLinkCondition || pathname === link.to
        const linkColor = isActive ? 'text-accent' : 'text-white-yellow'

        return (
          <div
            key={`link-${link.label}-${link.to}`}
            className={`
            border-b-4 ${isActive ? 'border-accent' : 'border-transparent'}
          `}
          >
            <Link className={`h-full hover:opacity-50 ${linkColor}`} key={`${link.to}`} to={link.to}>
              <div
                className={`
                  flex flex-col justify-center items-center
                  py-4 gap-2 h-full text-center
                `}
              >
                {link.Icon ? <link.Icon className="w-6 h-6" /> : null}
                <span className="px-2">{link.label}</span>
              </div>
            </Link>
          </div>
        )
      })}
      <div className="flex flex-col justify-center text-lg">
        <PiCaretRight color="white" />
      </div>
    </div>
  )
}

export default Tabs
